const BASE_CLASSES = "text-m text-p6-orange cursor-pointer";

/** For elements that must look like a LinkButton without being a <button> (e.g. a download link). */
export const LINK_BUTTON_LOOKALIKE_CLASSES = `${BASE_CLASSES} hover:text-p6-orange-darker`;

interface LinkButtonProps {
    children: string;
    onClick: () => void;
    disabled?: boolean;
    "data-testid"?: string;
}

/** Button styled as a text link, for the least prominent action in a form or popup. */
const LinkButton = (props: LinkButtonProps) => {
    return (
        <button
            data-testid={props["data-testid"]}
            type="button"
            onClick={props.onClick}
            disabled={props.disabled}
            className={`p-no bg-transparent border-none ${BASE_CLASSES} enabled:hover:text-p6-orange-darker disabled:cursor-not-allowed disabled:opacity-60`}
        >
            {props.children}
        </button>
    );
};

export default LinkButton;
